import { render, staticRenderFns } from "./QuadroResumoRateiosEdicao.vue?vue&type=template&id=7b53e176"
import script from "./QuadroResumoRateiosEdicao.vue?vue&type=script&lang=js"
export * from "./QuadroResumoRateiosEdicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports